export class DadosRelatorioEntregador {
  entregadorId: number;
  dataBase: Date;
}
